import { styled, alpha } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';

const Container = styled('div')(({ theme, justifyContent }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: justifyContent || 'initial'
}));

const TextStyleBase = styled('span', {
  shouldForwardProp: prop => prop !== 'small'
})(
  ({
    theme,
    color,
    backgroundColor,
    text,
    textAlphaValue,
    alphaValue,
    fontSize,
    lineHeight,
    minWidth,
    showBorder,
    justifyContent,
    whiteSpace = 'normal',
    small = false
  }) => ({
    textTransform: 'capitalize',
    fontWeight: theme.typography.fontWeightBold,
    padding: small ? theme.spacing(0.25, text ? 0.5 : 0.25) : theme.spacing(0.5, text ? 1 : 0.5),
    borderRadius: theme.shape.borderRadius,
    display: 'flex',
    alignItems: 'center',
    color: alpha(color, textAlphaValue),
    backgroundColor: alpha(backgroundColor || color, alphaValue),
    fontSize: fontSize || 'inherit',
    lineHeight: `${lineHeight || fontSize}px` || 'normal',
    minWidth: minWidth || 'auto',
    whiteSpace: whiteSpace,
    border: showBorder ? `1px solid ${alpha(color, textAlphaValue)}` : 'none',
    justifyContent: justifyContent || 'initial'
  })
);

function NRHighlightedText({
  style,
  text,
  color,
  colorAlt,
  backgroundColor,
  icon,
  fontSize,
  lineHeight,
  highlightAll = false,
  alphaValue = 0.15,
  tooltipContent = '',
  minWidth = null,
  showBorder = false,
  justifyContent = null,
  handleOnClick,
  textAlphaValue = 1,
  small,
  whiteSpace,
  variant = 'subtitle2'
}) {
  return (
    <Tooltip title={tooltipContent} placement="top">
      <Container style={style} justifyContent={justifyContent} onClick={handleOnClick}>
        {!highlightAll && icon}
        <TextStyleBase
          color={color}
          backgroundColor={backgroundColor}
          fontSize={fontSize}
          lineHeight={lineHeight}
          text={text}
          alphaValue={alphaValue}
          minWidth={minWidth}
          showBorder={showBorder}
          justifyContent={justifyContent}
          textAlphaValue={textAlphaValue}
          small={small}
          whiteSpace={whiteSpace}
        >
          {highlightAll && icon}
          <Typography variant={variant} color={colorAlt}>
            {text}
          </Typography>
        </TextStyleBase>
      </Container>
    </Tooltip>
  );
}

export default NRHighlightedText;
